import python from "../images/python.png"
import git from "../images/git.png"
import responsiveWeb from "../images/responsive-web.webp"
import reactjs from "../images/reactjs.png"
import mongodb from "../images/mongodb.png"
import nodejs from "../images/nodejs.png"
import html from "../images/html.png"
import css from "../images/css.png"
import javascript from "../images/javascript.png"
import sass from "../images/sass.png"
import tailwindCSS from "../images/tailwind.png"
import styled from "../images/styled.png"


// --------------------------------------- Project List
export const ProjectList = [
  {
    title: "Yodaskill - Scripting Better Education",
    description: "The Edutech Candidate Assessment and Hiring Platform is a comprehensive solution designed for staffing and recruiting purposes.",
    tech_stack: "ReactJS , NodeJS , ExpressJS , MySQL , Redux-Toolkit , Git .",
    github_url: "https://github.com/Sasikumaryanapu",
    demo_url: "https://yodaskill.com",
  },
  {
    title: "Web Scraping and SEO Optimization",
    description: "Enhancing online visibility through effective web scraping and SEO optimization strategies .",
    tech_stack: "ReactJS , Python , Flask , MySQL ",
    github_url: "https://github.com/Sasikumaryanapu",
    demo_url: "",
  },
  {
    title: "Dundo",
    description: "Recreated the sleek UI of Urban Company with a strong emphasis on user authentication. While it's a UI clone, the platform maintains simplicity and secure user access.",
    tech_stack: "ReactJs , Nodejs , Expressjs , MongoDB , Redux Toolkit",
    github_url: "https://github.com/Sasikumaryanapu/sasi-portfolio.git",
    demo_url: "https://dundo.netlify.app/",
  },
  // {
  //   title: "Cityguide",
  //   description: "This is an guide about the tourists places for travllers. ",
  //   tech_stack: "Reactjs, Css",
  //   github_url: "https://github.com/Sasikumaryanapu/citytour.git",
  //   demo_url: "https://sasikumaryanapu.github.io/citytour/",
  // },
  // {
  //   title: "Instagram Clone",
  //   description: "I have created a functional clone of instagram using global state management and single page application library ",
  //   tech_stack: "Reactjs, Zustand ,Css",
  //   github_url: "https://your_project_github_link",
  //   demo_url: "https://your_project_demo_link",
  // },
  // {
  //   title: "Portfolio",
  //   description: "Ofcourse i made my own personal portfolio website.",
  //   tech_stack: "Reactjs, Css",
  //   github_url: "https://your_project_github_link",
  //   demo_url: "https://your_project_demo_link/",
  // },
  {
    title: "RestAPI ",
    description:"Created an  restapi for notebook using nodejs and mongoDB Atlas database",
    tech_stack: "Nodejs , Expressjs , MongoDB",
    github_url: "https://github.com/Sasikumaryanapu/notebook.git",
    demo_url: "https://github.com/Sasikumaryanapu/notebook.git",
  }
 
];

// --------------------------------------- Skills

export const stackList = [
  {
    img: html,
    name: "HTML",
  },
  {
    img: css,
    name: "CSS",
  },
  {
    img:javascript,
    name: "JavaScript",
  },
  {
    img:reactjs,
    name: "ReactJS",
  },
  {
    img:nodejs,
    name: "NodeJS",
  },
  {
    img:mongodb,
    name: "MongoDB",
  },
  {
    img:python,
    name: "Python",
  },
  {
    img: git,
    name: "Git",
  },
  {
    img:responsiveWeb,
    name: "Responsive",
  },
  {
    img: tailwindCSS,
    name: "TailwindCSS",
  },
  {
    img:sass,
    name: "Sass",
  },
  {
    img:styled,
    name: "Styled-Components",
  }
];
